import { BaseModel } from "./BaseModel";
import IGambleData from "../server/data/IGambleData";

class GambleModel extends BaseModel<IGambleData> {
    public gambleButtonClicked: boolean;
}

export default new GambleModel();